<app-navbar-style-two></app-navbar-style-two>
<div class="cot">
    <div class="container text-center">
        <h1 i18n style="color: white;">Stay Tuned: MEDEIL’s Next-Gen POS Features Are<br><b>Coming Soon</b></h1>
        <p i18n style="color: white;">Exciting updates are on the way! MEDEIL is preparing to launch innovative new features for our retail and pharmacy POS solutions, designed to help your business grow and deliver an even better customer experience. Whether you’re looking for advanced POS updates, smarter business analytics, or enhanced usability, our upcoming release will take your operations to the next level.</p>
    </div>

<div class="cot3">
    <div class="container text-center ">
        <div class="cta-section">
        <h2 i18n>What’s Next for MEDEIL Retail & Pharmacy POS?</h2>
        <p i18n>We’re committed to continuous improvement and innovation. Our roadmap includes powerful new POS features, seamless integrations, and performance upgrades for both retail and pharmacy businesses. Stay tuned for:</p>
                <ul i18n style="display: inline-block; text-align: left; color: black;">
                <li>Enhanced POS innovation and smarter workflows</li>
                <li>New business software releases tailored to your needs</li>
                <li>Retail POS launches and pharmacy POS upgrades</li>
                <li>Improved customer management and reporting tools</li>
                <li>And Much More</li>
            </ul>
            </div>
        </div>
    </div>
    <section class="hosbay-section">
        <div class="">
            <div class="cta-section">
            <p i18n >Bookmark this page and check back soon for the official launch. Want to be the first to know? <a routerLink="/contact-us" style="color: #0de6c5;">Contact us</a> to join our update list and get exclusive previews of MEDEIL’s next-gen POS features.</p>
            </div>
        </div>
    </section>
</div>
<app-footer-style-two></app-footer-style-two>